const dataProtocol = [
  {
    technology: 'REST',
  },
  {
    technology: 'SOAP',
  },
  {
    technology: 'HL7/FHIR',
  },
  {
    technology: 'GraphQL',
  },
];

export default dataProtocol;
